import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=20684153&scoped=true"
import script from "./MediaDetail.vue?vue&type=script&lang=js"
export * from "./MediaDetail.vue?vue&type=script&lang=js"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=20684153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20684153",
  null
  
)

export default component.exports